/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ListPositions200AllOf
} from './schema'



/**
 * Get a list of Positions
 * @summary Get Positions
 */
export const listPositions = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ListPositions200AllOf>> => {
    return axios.get(
      `/positions`,options
    );
  }


export const getListPositionsQueryKey = () => [`/positions`];

    
export type ListPositionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPositions>>>
export type ListPositionsQueryError = AxiosError<unknown>

export const useListPositions = <TData = Awaited<ReturnType<typeof listPositions>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPositions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPositionsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPositions>>> = ({ signal }) => listPositions({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listPositions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

